import React from "react";

const formatLocation = (location) => {
  if (!location?.lat || !location?.lng) return "—";
  return `${Number(location.lat).toFixed(5)}, ${Number(location.lng).toFixed(5)}`;
};

const osmUrl = (location) =>
  `https://www.openstreetmap.org/?mlat=${location.lat}&mlon=${location.lng}#map=16/${location.lat}/${location.lng}`;

const LocationOrder = ({ address, location }) => {
  if (!location?.lat || !location?.lng) return <span>—</span>;
  return (
    <a
      className="rounded bg-blue-500 py-2 px-4 font-bold text-white hover:bg-blue-700"
      href={osmUrl(location)}
      target="_blank"
      rel="noreferrer"
    >
      {address || formatLocation(location)}
    </a>
  );
};

export default LocationOrder;
